import createCache from '@emotion/cache';

export function createEmotionCache(key: string) {
  return createCache({ key, prepend: true });
}
